module.exports = __webpack_public_path__ + "img/finland-breast-cancer-female.3ec1f77f.png";